import { useRef } from "react";
import { useDrag } from "react-dnd";

interface Props {
  dndType: string;
  index?: number;
  item: unknown;
}

export default function useDraggable({ dndType, index, item }: Props) {
  const ref = useRef<HTMLDivElement>(null);

  const [{ isDragging }, drag] = useDrag({
    type: dndType,
    item: () => ({ index, item, dndType }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(ref);

  return { isDragging, ref };
}
